'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$form = _themes.componentThemes.form,
  checkboxStyle = _componentThemes$form.checkboxStyle,
  formTheme = _componentThemes$form.formTheme;
Checkbox.propTypes = {
  theme: _propTypes.object.isRequired,
  selected: _propTypes.bool
};
Checkbox.defaultProps = {
  selected: false
};
function Checkbox(_ref) {
  var baseTheme = _ref.theme,
    selected = _ref.selected;
  var theme = formTheme(baseTheme);
  return _react2.default.createElement(_glamorous2.default.Svg, {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 32 32',
    height: '20px',
    minHeight: '20px',
    width: '20px',
    minWidth: '20px',
    margin: theme[checkboxStyle('marginTop')] + ' 10px 0 0'
  }, _react2.default.createElement('title', null, 'Checkbox'), _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M3.2 0h25.6A3.2 3.2 0 0 1 32 3.2v25.6a3.2 3.2 0 0 1-3.2 3.2H3.2A3.2 3.2 0 0 1 0 28.8V3.2A3.2 3.2 0 0 1 3.2 0z',
    fill: selected ? theme[checkboxStyle('color', 'selected')] : theme[checkboxStyle('color')]
  }), _react2.default.createElement('path', {
    d: 'M4 1h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z',
    fill: theme[checkboxStyle('backgroundColor')]
  }), selected && _react2.default.createElement('path', {
    d: 'M23.28 9.1l-.91-.74a1 1 0 0 0-1.37.13l-7.72 11.07-2.21-2.72a1 1 0 0 0-1.4-.17l-.9.73a1 1 0 0 0-.17 1.4l3.85 4.73a1.57 1.57 0 0 0 1.66.19c.553-.431.993-.99 1.28-1.63l8-11.63a1 1 0 0 0-.11-1.36z',
    fill: selected ? theme[checkboxStyle('color', 'selected')] : theme[checkboxStyle('color')]
  })));
}
exports.default = (0, _glamorous.withTheme)(Checkbox);